import { jsx as _jsx } from "react/jsx-runtime";
const Col = ({ children, className = '', reverse = false, style: customStyle = {}, xs, sm, md, lg, }) => {
    // Use the largest defined breakpoint for base width
    const colSize = lg || md || sm || xs || 12;
    const percentage = (100 / 12) * Number(colSize);
    const style = {
        boxSizing: 'border-box',
        flex: '0 0 auto',
        padding: 0,
        flexBasis: `${percentage}%`,
        maxWidth: `${percentage}%`,
        display: 'block',
        ...(reverse ? { flexDirection: 'column-reverse' } : {}),
        ...customStyle,
    };
    return (_jsx("div", { className: className, style: style, children: children }));
};
Col.displayName = 'Col';
export default Col;
//# sourceMappingURL=col.js.map